import { FieldErrors, FieldValues } from 'react-hook-form'
import { NctsError } from '../../../../../shared/ncts/types'

function isLeafNode(node: any) {
  return !!node && typeof node === 'object' && ('type' in node || 'message' in node)
}

function mapFieldErrorsToNctsErrors<TFieldValues extends FieldValues>(fieldErrors: FieldErrors<TFieldValues>) {
  const result: NctsError[] = []
  const visited = new WeakSet<object>()

  const collectErrors = (node: any, pathPrefix = ''): void => {
    if (!node || typeof node !== 'object') return

    if (visited.has(node)) return
    visited.add(node)

    if (isLeafNode(node)) {
      const type = String(node.type) ?? ''
      if (type.startsWith('ncts')) {
        const [, code] = type.split(':')
        result.push({
          scope: 'transitOperation',
          code,
          path: pathPrefix,
          message: node.message ?? '',
        })
      }
    }

    if (Array.isArray(node)) {
      node.forEach((child, index) => {
        if (child === null) return
        const childPath = pathPrefix ? `${pathPrefix}.${index}` : String(index)
        collectErrors(child, childPath)
      })
      return
    }

    Object.entries(node).forEach(([key, child]) => {
      if (key === 'ref') return
      const childPath = pathPrefix ? `${pathPrefix}.${key}` : key
      collectErrors(child, childPath)
    })
  }

  collectErrors(fieldErrors)

  return result
}

export default mapFieldErrorsToNctsErrors
